"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WhyHomeownersTrustArborPro() {
  const image1 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const image2 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const eyebrow = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const heading = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.2
  });
  const para1 = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.2
  });
  const para2 = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.2
  });
  const cta = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="3680" id="why-homeowners-trust-arbor-pro" className="relative bg-background text-foreground overflow-hidden py-24 md:py-32 lg:py-[200px]">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-1/2 hidden lg:block w-[33%] -translate-x-[10%] bg-accent/40" />

      <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-y-16 lg:gap-x-8">
          {}
          <div ref={image1.ref} className={`lg:col-span-4 lg:col-start-1 lg:mt-20 transition-all duration-1000 ease-out ${image1.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            <div className="overflow-hidden rounded-lg shadow-lg">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697657/img/arborist_inspecting_canopy.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697657/img/arborist_inspecting_canopy.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697657/img/arborist_inspecting_canopy.png-wvc-sizes" alt="Professional arborist inspecting a healthy tree canopy" loading="lazy" decoding="async" className="w-full h-auto aspect-[3/4] object-cover" />
            </div>
          </div>

          {}
          <div className="lg:col-span-7 lg:col-start-6 relative">
            <div ref={eyebrow.ref} className={`transition-all duration-700 ease-out ${eyebrow.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
              <span className="font-mono text-xs sm:text-sm uppercase tracking-[0.25em] text-muted-foreground">
                02 — Our Commitment
              </span>
            </div>

            <h2 ref={heading.ref} className={`mt-8 font-default font-sans font-light text-foreground text-4xl sm:text-5xl lg:text-6xl xl:text-[64px] leading-[1.05] tracking-tight transition-all duration-1000 ease-out delay-100 ${heading.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
              Safety Rooted in{" "}
              <span className="italic block lg:inline lg:pl-12" style={{
              color: "var(--chart-1)"
            }}>
                Expertise
              </span>
            </h2>

            <div className="mt-10 lg:mt-14 max-w-[480px] space-y-6 font-default">
              <p ref={para1.ref} className={`text-[17px] leading-[1.7] transition-all duration-1000 ease-out delay-200 ${para1.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
              color: "var(--chart-5)"
            }}>
                At Arbor Pro, every tree service begins with a deep respect for the landscape. We do not just trim branches — we cultivate long-term health, ensuring your property remains safe, vibrant, and structurally sound through precise, science-backed care.
              </p>
              <p ref={para2.ref} className={`text-[17px] leading-[1.7] transition-all duration-1000 ease-out delay-300 ${para2.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
              color: "var(--chart-5)"
            }}>
                Certified by industry leaders, our team approaches every project with unmatched technical rigor. An Arbor Pro intervention is designed to protect your investment, enhance your curb appeal, and ensure your trees thrive for generations to come.
              </p>
            </div>

            <div ref={cta.ref} className={`mt-12 transition-all duration-1000 ease-out delay-500 ${cta.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
              <Link to="/OurExpertisePage" className="group inline-flex items-center gap-3 font-mono text-sm uppercase tracking-[0.2em] text-foreground border-b border-foreground/30 pb-2 hover:border-foreground transition-colors">
                <span>View our expertise</span>
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
              </Link>
            </div>

            {}
            <div ref={image2.ref} className={`mt-16 lg:mt-24 lg:absolute lg:right-0 lg:bottom-0 lg:-mb-20 lg:w-[42%] lg:max-w-[280px] lg:translate-x-10 transition-all duration-1000 ease-out delay-400 ${image2.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
              <div className="overflow-hidden rounded-lg shadow-lg">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697657/img/tree_health_assessment.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697657/img/tree_health_assessment.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697657/img/tree_health_assessment.png-wvc-sizes" alt="Detailed tree health assessment tools" loading="lazy" decoding="async" className="w-full h-auto aspect-square object-cover" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}